export const FIELD_VARIANTS = { OUTLINED: 'outlined' }
